import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React, { useState, useEffect } from 'react';
import InputCheckbox from './Checkbox.js';

var _excluded = ["className", "data-testid", "defaultValue", "disabled", "error", "id", "onChange", "onClick", "onUpdate", "options", "optionsProps", "required", "value"];
var InputCheckboxes = function InputCheckboxes(_ref) {
  var className = _ref.className,
    dataTestId = _ref['data-testid'],
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    error = _ref.error,
    id = _ref.id,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onUpdate = _ref.onUpdate,
    options = _ref.options,
    optionsProps = _ref.optionsProps,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    propsValue = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (onChange || onClick) {
    console.error("Hey Canvas User! onChange and onClick are not supported by this component, please use onUpdate instead.");
  }
  if (!id) {
    console.error("Hey Canvas User! A unique id is required for the checkboxes input.");
  }
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    // only run if there is a passed value and if the passed value does not equal the current value
    if (value && value !== propsValue) {
      setValue(propsValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, propsValue]);
  var finalClasses = classnames('C-Input--type-checkboxes', className);

  // Check for a default value
  var hasDefaultValue = defaultValue ? function (checkboxDefaultValue) {
    return defaultValue.indexOf(checkboxDefaultValue) !== -1;
  } : function () {
    return false;
  };

  // Check for a value
  var hasValue = value ? function (checkboxValue) {
    return value.indexOf(checkboxValue) !== -1;
  } : function () {
    return false;
  };
  var handleOnChange = function handleOnChange(checkboxValue) {
    return function (event) {
      var nextValue = value;
      if (event.target.checked && nextValue && nextValue.indexOf(checkboxValue) === -1) {
        nextValue = nextValue.concat(checkboxValue);
      } else if (nextValue && nextValue.indexOf(checkboxValue) !== -1) {
        var index = nextValue.indexOf(checkboxValue);
        nextValue = [].concat(_toConsumableArray(nextValue.slice(0, index)), _toConsumableArray(nextValue.slice(index + 1)));
      } else {
        return;
      }
      setValue(nextValue);
      onUpdate && onUpdate(name || id, nextValue);
    };
  };
  return /*#__PURE__*/React.createElement("fieldset", _extends({
    "data-testid": dataTestId,
    className: finalClasses
  }, otherProps), /*#__PURE__*/React.createElement("ledgend", {
    className: "hc-sr-only"
  }, "Group of ".concat(options.length, " checkboxes. ").concat(required ? 'You must select at least one option.' : '')), options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(InputCheckbox, _extends({
      disabled: option.disabled || disabled,
      "data-testid": dataTestId ? "".concat(dataTestId, "_").concat(option.value) : '',
      highlight: option.highlight,
      id: "".concat(id, "_").concat(option.value),
      key: "".concat(id, "_").concat(option.value),
      label: option.label,
      onChange: handleOnChange(option.value),
      value: option.value,
      checked: hasValue(option.value) || hasDefaultValue(option.value),
      error: error
    }, optionsProps));
  }));
};
InputCheckboxes.displayName = 'Input.Checkboxes';

export { InputCheckboxes as default };
